import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, DatePipe, isPlatformBrowser, NgClass, NgFor, NgIf, NgSwitch } from '@angular/common';
import { Component, computed, effect, EventEmitter, inject, Input, input, OnDestroy, OnInit, Output, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCrown, faLink, faLock, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DateTime } from 'luxon';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GalleriaModule } from 'primeng/galleria';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { distinctUntilChanged, Subscription, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IAskAQuestionRequest } from '../../models/IAskAQuestionRequest';
import { IBiddingRequest } from '../../models/IBiddingRequest';
import { IFeeRequest } from '../../models/IFeeRequest';
import { IItem } from '../../models/IItem';
import { IItemBidHistory } from '../../models/IItemBidHistory';
import { IItemDetails } from '../../models/IItemDetails';
import { ILineItems } from '../../models/ILineItems';
import { ITieDetails } from '../../models/ITieDetails';
import { ApiService } from '../../services/api.service';
import { AuthService, LOGIN_TYPE_BID_INLINE, LOGIN_TYPE_TICKETS, LOGIN_TYPE_TOPBAR } from '../../services/authentication/auth.service';
import { BidService } from '../../services/bidding/bid.service';
import { DateFormatService } from '../../services/date-format/date-format.service';
import { EmbeddedPaymentService } from '../../services/epf/embedded-payment.service';
import { FavoritesItemsService } from '../../services/favorites/favorites-items.service';
import { ModalService } from '../../services/modals/modal.service';
import { RecaptchaLoaderService } from '../../services/recaptcha-loader.service';
import { ThemeService } from '../../services/theme.service';
import { TimeLeftService } from '../../services/time-left.service';
import { ToastMessageService } from '../../services/toast-message/toast-message.service';
import { CaptionBidPipe } from '../../shared/pipes/caption-bid-history/caption-bid.pipe';
import { DonorsComponent } from '../auctions/donors/donors.component';
import { CreditCardInformationComponent } from '../authentication/credit-card-information/credit-card-information.component';
import { SignInComponent } from '../authentication/sign-in/sign-in.component';
import { BelowReserveBidComponent } from '../bid-history-modals/below-reserve-bid/below-reserve-bid.component';
import { BelowReserveComponent } from '../bid-history-modals/below-reserve/below-reserve.component';
import { ReserveMetComponent } from '../bid-history-modals/reserve-met/reserve-met.component';
import { StraightBidComponent } from '../bid-history-modals/straight-bid/straight-bid.component';
import { TieBidComponent } from '../bid-history-modals/tie-bid/tie-bid.component';
import { EmbeddedPaymentComponent } from '../embedded-payment/embedded-payment.component';
import { GalleryFullImageComponent } from '../gallery-full-image/gallery-full-image.component';
import { AbsenteeBiddingComponent } from './absentee-bidding/absentee-bidding/absentee-bidding.component';
import { BiddingQuestionMarkComponent } from './bidding-question-mark/bidding-question-mark.component';
import { ItemHorizontalViewComponent } from './item-horizontal-view/item-horizontal-view.component';
import { ItemVerticalViewComponent } from './item-vertical-view/item-vertical-view.component';




@Component({
  selector: 'app-items',
  imports: [NgIf,
    ButtonModule,
    NgClass,
    ItemHorizontalViewComponent,
    ItemVerticalViewComponent,
    DialogModule,
    NgFor,
    FormsModule,
    SelectModule,
    InputNumber,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    TabsModule,
    AccordionModule,
    DialogModule,
    TextareaModule,
    CommonModule,
    DonorsComponent,
    DynamicDialogModule,
    EmbeddedPaymentComponent,
    RadioButtonModule,
    SignInComponent,
    RouterModule,
    BiddingQuestionMarkComponent,
    ProgressSpinnerModule,
    StraightBidComponent,
    ReserveMetComponent,
    BelowReserveBidComponent,
    FontAwesomeModule,
    TieBidComponent,
    CaptionBidPipe,
    GalleriaModule,
    MessageModule,
    GalleryFullImageComponent,
    AbsenteeBiddingComponent,
    ClipboardModule
  ],
  providers: [DatePipe, DialogService, NgSwitch],
  templateUrl: './items.component.html',
  styleUrl: './items.component.scss'
})
export class ItemsComponent implements OnInit, OnDestroy {

  @Input() items: IItem[] = [];
  @Input() isHomePage: boolean = true;
  @Input() viewMode: 'image' | 'list' = 'image';
  @Input() itemId!: number;
  @Input() auctionId?: number;
  displayQuestionModal = false;
 displayFullScreen = false;

  // Modal
  displayModal: boolean = false;
  selectedItemId!: number;
  filteredTab: { value: number, title: string }[] = [];
  itemModal?: IItemDetails | null = null;
  quantity: number = 1;
  selectedCardId!: number;
  // cardOptions: ICreditCardOption[] = [];
  selectedBid: string = '';
  selectedBidOption: 'STRAIGHT' | 'PROXY' = 'PROXY';
  formatPlacedOnDate: string | null = '';
  formatBidHistory: IItemBidHistory[] = [];
  public bidPlaceholder = '';

  authenticatedInsideModal: boolean = false;
  @Output() modalStatusChanged = new EventEmitter<{
    refreshNeeded: boolean
  }>(); //to know if there was a login or placed a bid
  refreshNeeded: boolean = false;
  errorMessage: string | null = null;
  cardNameDisplay: string | null = null;

  // bid
  coverFeeConfirm: boolean = false;
  bidResponseSignal = signal<string | null>(null);
  showConfirmTemplate: boolean = false;
  showLowBidError: boolean = false;
  apiBidError!: string;
  showBidStatus: boolean = false;
  isLeader: boolean = false;
  lastItemId: number | null = null;
  myBidLabel!: string;
  showMaxBidError: boolean = false;


  //Bid history Modals
  displayStraigthBidModal: boolean = false;
  displayBelowReserveBidModal: boolean = false;
  displayReserveExplanationBidModal: boolean = false;
  displayReserveMetBidModal: boolean = false;
  displayTieWinBidModal: boolean = false;
  activeCaption: string | null = null;
  tieDetails: ITieDetails | null = null;

  displayAbsenteeBiddingModal = false;
  paymentService = inject(EmbeddedPaymentService)
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly modalService = inject(ModalService);
  private readonly biddingService = inject(BidService);
  private readonly apiService = inject(ApiService);
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly timeLeftService = inject(TimeLeftService);
  private readonly themeService = inject(ThemeService);

  feeSignal = this.paymentService.feeSignal;
  feeSignalValue: number | 0 = 0;
  itemBidHistory = signal<IItemBidHistory[]>([]);
  userName!: string | null;

  idItemDetails: number = 0;
  token: string = '';
  visibleEmbedded: boolean = false;
  itemMinimunBid!: number
  itemMaximunBid!: number


 galleryFormatted: any[] = [];
 galleryFullscreen: any[] = [];

  gallery: string[] = [];
  selectedImage!: string;
  activeIndex: number = 0;
  responsiveOptions: any[] = [
    {
      breakpoint: '1300px',
      numVisible: 4
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ];


  //favorite
  isFavorited: boolean | null = null;
  private readonly favoriteService = inject(FavoritesItemsService);
  authSubscription!: Subscription;
  isAuthenticatedFavorited!: boolean;

  //Ask a question
  askAQuestionControl: string = '';
  userEmail!: string;
  responseError!: string;

  //reCAPTCHA
  private readonly recaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly recaptchaLoader = inject(RecaptchaLoaderService);

  //api message service
  private readonly messageService = inject(ToastMessageService);

  //formate date service
  private readonly dateFormatService = inject(DateFormatService)

  faLock = faLock;
  faSquareCheck = faSquareCheck
  faCrown = faCrown;
  faLink = faLink;

  //Social media
  protected icons = {
    faFacebook: faFacebook,
    faLinkedin: faLinkedin,
    faXTwitter: faXTwitter,
    faInstagram: faInstagram
  }
  public shareTextInput = input("");

  private readonly meta = inject(Meta);
  private readonly titleService = inject(Title);



  embeddedToken: string | null = null;
  winninBid: string = "The winning bid will  go to FrontStream Global Fund (tax ID 26-3265577), a 501c3 nonprofit organization, which  will send the payment to VOLUNTEERS OF AMERICA INC (tax ID 000000001) on behalf of the winner.";
  itemType: 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' = 'event';
  bidType: 'LEADER_PROXY_BID' | 'LEADER_BELOW_RESERVE' | 'LEADER_STRAIGHT_BID' | null = null;
  //Tabs
  activeTab: number = 0;

  protected creditCardErrorMessage = '';

  auctionConfigSignal = this.apiService.auctionConfigSignal;
  homePageData = computed(() => this.apiService.homePageSignal());


  itemDetailsSingalModal = computed(() => this.apiService.itemDetailSignal());
  safeDescriptionHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.description || ''));
  safeSpecialNoteHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.specialNote || ''));
  safeItemNameHtml = computed(() => this.sanitizeHtmlText(this.itemDetailsSingalModal()?.name || ''));

  itemDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const closingDate = this.itemDetailsSingalModal()?.closingDate;

    if (!closingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, closingDate);
  });

  openingDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const openingDate = this.itemDetailsSingalModal()?.openingDate;

    if (!openingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, openingDate);
  });

  showCoverTheFee = computed(
    () => this.auctionConfigSignal()?.isCoverTheFeeEnabled
  );


  itemFavoriteSignal = signal<boolean>(this.itemDetailsSingalModal()?.isFavorite ?? false);

  homePageSignal = this.apiService.homePageSignal;

  protected showWinningBidText = computed(() => {
    return this.apiService.auctionConfigSignal()?.processor === 'pgf'
  });

  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '')

  isAbsenteeBiddingEnabled = computed(
      () => this.apiService.auctionConfigSignal()?.isAbsenteeBiddingEnabled
    );


  cardOptions = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data) return [];

    return data.creditCards.map(card => ({
      label: `${card.type} ****${card.lastDigits}`,
      value: card.id
    }))
  })

  selectedCard = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data || data.creditCards.length === 0) return 0;

    const preferredCard = data.creditCards.find(card => card.id === data.preferredCardId);

    return preferredCard ? preferredCard.id : data.creditCards[0].id
  })

  feeAmountSignal = computed(() => {
    const feeEndpoint = this.paymentService.feeSignal();
    if (!feeEndpoint) return 0;

    return feeEndpoint;

  })

  private getCreditCardErrorMessage = (cardId:number|null|undefined) => {
    if (cardId === null || cardId === undefined) {
      return 'Please select a card to place your bid.'
    }
    return '';
  }

  authService = inject(AuthService);
  isAuthenticated = this.oidcSecurityService.authenticated;
  isShowingLoginIframe = signal(false);
  loginPage = LOGIN_TYPE_BID_INLINE;
  loginUrl = signal('');

  constructor(private router: Router,
    private sanitizer: DomSanitizer,
    private ref: DynamicDialogRef,
    private dialogService: DialogService,
    private datePipe: DatePipe,
    private renderer: Renderer2) {

    effect(() => {
      const dataFee = this.paymentService.feeSignal();
      if (dataFee) {
        // console.log('Fee', dataFee);
      }

      // const dateFormat = this.auctionConfigSignal();
      // if (dateFormat) {
      //   console.log(dateFormat.timezone);
      // }

      const item = this.itemDetailsSingalModal();
      if (item) {
        this.isFavorited = item.isFavorite;
      }

      const creditCardsSignal = this.authService.creditCardSignal();
      if (creditCardsSignal?.creditCards && creditCardsSignal.creditCards.length > 0) {
        this.selectedCardId = this.selectedCard();
      }

    });
  }

  private unlistenMessage?: () => void; // for cleanup
  ngOnInit(): void {
    this.recaptchaLoader.load();

      this.themeService.customizeAuctionTheme(this.auctionId!);
      this.themeService.setPreset('bfg');


    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (isAuth) {
        if (this.displayModal && this.lastItemId) {
          this.getItemDetails(this.lastItemId);
          this.isAuthenticatedFavorited = true;

        } else {
          this.isAuthenticatedFavorited = false;

        }
      }
    });


    if (!this.auctionConfigSignal()) {
      this.apiService.getAuctionConfig(this.auctionId ?? 0).subscribe();
    }

    // Add window message listener for Unavailable Notification support
    this.unlistenMessage = this.renderer.listen('window', 'message', this.onHandleEpfMessage);
  }

  ngOnDestroy() {
    this.recaptchaLoader.unload();
    this.authSubscription?.unsubscribe();
    // clean up the window listener if it was registered
    if (this.unlistenMessage) {
      this.unlistenMessage();
      this.unlistenMessage = undefined;
    }
  }

  onHandleEpfMessage = (event: any) => {
    // console.log(event.data);

    if (event.data !== null) {
      if (event.data.type === "ITEM_UNAVAILABLE") {
        this.visibleEmbedded = false; // this closes modal
        window.location.reload();
        // If we want to route somewhere else, example:
        // this.route.navigate(['/itemunavailable']);
      } else if (event.data.type === "EPF_REDIRECT_PARENT_WITH_URL" && event.data.url) {
        // console.log('Redirect to Thank You page');
        this.visibleEmbedded = false; // this closes modal
        window.location.replace(event.data.url);
      }

    }
  };

  onOpenModalItems(itemId: number): void {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
    this.showBidStatus = false;
    this.bidResponseSignal.set('');
    this.selectedBidOption = 'PROXY';
    this.selectedBid = '';
    this.coverFeeConfirm = this.auctionConfigSignal()?.isCoverTheFeeEnabled &&
      this.auctionConfigSignal()?.isCoverTheFeeOnByDefault ? true : false;

    // console.log(this.isAuthenticated().isAuthenticated)


    const itemSelected = this.getItemFromList(itemId)
    if (itemSelected) {
      const itemType = this.resolveItemType(itemSelected);
      if (itemType === 'buy') {
        this.router.navigate([`/auctions/${this.auctionId}/items/${itemId}`]);
      }
      else {
        this.getItemDetails(itemId);
        this.lastItemId = itemId;
      }
    }

    if (!environment.production) {
      console.log("Item Id: " + itemId);
    }

  }

  onCloseModal() {
    this.displayModal = false;
    this.lastItemId = null;

    this.modalStatusChanged.emit({
      refreshNeeded: this.refreshNeeded,
    });
    this.modalService.modalOpen.set(false);
  }

  onBuyNowFullPage(itemId: number): void {
    this.router.navigate([`/auctions/${this.auctionId}/items/${itemId}`]);
  }

  getItemFromList(itemId: number): IItem | undefined {
    return this.items.find(item => item.id === itemId);
  }


  getItemDetails(itemId: number): void {

    this.activeTab = 0;
    this.itemMinimunBid = 0;
    this.itemMaximunBid = 0;

    this.hideError();

    // this.modalStateChanged.emit('open'); //notify item listing modal is open

    const endpoint = 'items';

    this.apiService.getItemById(endpoint, itemId).pipe(
      tap({
        next: (response) => {

          const item = this.itemDetailsSingalModal();

          // console.log(item)

          this.displayModal = true;
          this.idItemDetails = item!.id;
          this.activeIndex = 0;
          this.gallery = [];
          this.feeSignal.set(0);


          if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()?.creditCards) {
            this.authService.getCreditCard().subscribe();
          }

          this.modalService.modalOpen.set(true);
          if (item?.minimumBid) {
            this.itemMinimunBid = parseFloat(item!.minimumBid.replace(/[^0-9.]/g, ''));
          }

          if (item?.myMaxBid) {
            this.itemMaximunBid = parseFloat(item!.myMaxBid.replace(/[^0-9.]/g, ''));
          }

          if (item?.isFavorite) {
            this.isFavorited = item?.isFavorite;
            this.itemFavoriteSignal.set(this.isFavorited);
          }

          if (item?.isLeader) {
            this.isLeader = item?.isLeader
          }

          if (item) {

            this.itemModal = item;

            // console.log(this.itemModal);

            //populate gallery
            const mainImage = item.imageUrl?.trim()
              ? (item.imageUrl.startsWith('http') ? item.imageUrl : `${environment.apiUrl}/${item.imageUrl.trim()}`)
              : '/item-default.jpg';
            this.itemModal.imageUrl = mainImage;
            this.selectedImage = mainImage;


            const additionalImages = (item.additionalImagesUrls || [])
              .filter(img => img && img.trim() && img.trim() !== item.imageUrl?.trim())
              .map(img => img.startsWith('http') ? img.trim() : `${environment.apiUrl}/${img.trim()}`);


            // setTimeout(() => {
              this.gallery = [mainImage, ...additionalImages];
              this.selectedImage = mainImage;
              this.activeIndex = 0;

              this.galleryFormatted = this.gallery.map(img => ({
                itemImageSrc: img,
                thumbnailImageSrc: img
              }));
            // }, 0);

            this.bidPlaceholder = this.getBidPlaceholder();

            this.itemType = this.resolveItemType(item);

             if (this.itemModal.numberOfBids > 0 && (item.isBiddable || this.itemType === 'closed' )) {
              this.loadItemBidHistory(item.id);
              this.filteredTab = this.tabs;
            }else{
               this.filteredTab = this.tabs.filter(t => t.value !== 3);
            }
          }

          // this.filteredTab = this.itemModal?.isBiddable || this.itemType === 'closed'
          //   ? this.tabs
          //   : this.tabs.filter(t => t.value !== 3);
        },
        error: (error) => {
          console.error('Error fetching item details:', error);
        }
      })
    ).subscribe();
  }

  loadItemBidHistory(itemId: number): void {

    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userName = result.preferred_username
        // console.log('result', this.userName);
      }
    });

    const endpoint = 'items';
    this.apiService.getItemBidHistory(endpoint, itemId).pipe(

      tap({
        next: (response) => {

          this.formatBidHistory = JSON.parse(JSON.stringify(response));
          // console.log(this.formatBidHistory)
          this.formatBidHistory.forEach(bid => {
            if (bid.placedOn) {
              bid.placedOn = this.formatDate(bid.placedOn);
            }
          });
        },
        error: (error) => {
          console.error('Error fetching bid history:', error);

        }
      })
    ).subscribe();
  }

  openLoginModal() {
    // console.log("login")
    if (this.auctionId != undefined) {
      const isTestAuction = this.auctionConfigSignal()?.isTestAuction;
      this.authService.openLoginModal(
        LOGIN_TYPE_TICKETS,
        this.embeddedPaymentLoad,
        this.auctionId,
        this.embeddedPaymentLoad,
        '',
        { hideGuestOption: isTestAuction }
      );
    }
  }

  openLoginModalFavorite(fun?: () => void) {
    if (this.auctionId != undefined) {
      this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun, this.auctionId);
    }
    // this.isFavorited? = this.itemDetailsSingalModal()?.isFavorite;

  }

  embeddedPaymentLoad = (): void => {

    const lineItems: ILineItems[] = [
      { id: this.idItemDetails, type: 3, quantity: this.quantity, donationAmount: 0.0 }
    ];

    if (this.auctionConfigSignal()?.isTestAuction) {
      this.paymentService.postTestPurchase(this.auctionId!, lineItems).subscribe({
        next: () => {
          this.router.navigate(['/payment-successful']);
        },
        error: (error) => {
          console.error('Error processing test purchase:', error);
        }
      });
      return;
    }

    this.paymentService.postEmbeddedPayment(this.auctionId!, lineItems).subscribe({
      next: (token) => {
        this.openEmbeddedPayment(token);
      },
      error: (error) => {
        console.error('Error al obtener el token:', error);
      }
    })
  }

  openEmbeddedPayment(token: string) {
    this.token = token;
    this.visibleEmbedded = true;
  }

  private getItemStatus(item: any): 'upcoming' | 'open' | 'closed' | 'unknown' {
    if (!item?.openingDate || !item?.closingDate) return 'unknown';

    const openingDate = DateTime.fromISO(item.openingDate);
    const closingDate = DateTime.fromISO(item.closingDate);
    const now = DateTime.now();

    if (now < openingDate) return 'upcoming';
    if (now >= openingDate && now < closingDate) return 'open';
    return 'closed';
  }

  private resolveItemType(item: any): 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' {
    const status = this.getItemStatus(item);

    if (status === 'closed') return 'closed';
    if (status === 'upcoming' && item.biddingType !== 'LIVE_ONLY') return 'upcoming';
    if (item.biddingType === 'LIVE_ONLY') return 'event';
    if (item.biddingType === 'BUY_NOW_ONLY' && !item.isBuyable && !item.isBiddable) return 'sold';
    if (!item.isBuyable && !item.isBiddable && item.quantityAvailable === 0 && item.numberSold === 1) return 'sold';
    if (item.isBuyable && item.isBiddable) return 'buy-bid';
    if (item.isBuyable) return 'buy';
    if (item.isBiddable) return 'bid';
    return 'event';
  }

  // Tabs
  tabs = [
    { value: 0, title: 'Item Details' },
    { value: 1, title: 'Ask a question' },
    { value: 2, title: 'FAQ' },
    { value: 3, title: 'Bid History' }
  ];

  onTabChange(newTab: string | number | undefined) {
    // console.log(newTab);
    if (newTab !== 1) {
      this.askAQuestionControl = '';
      this.responseError = '';
    }
    this.activeTab = Number(newTab);
  }


  faqs = [
    { question: 'How to Login / Register as a Bidder', answer: 'To participate in bidding, you need to register and sign in as a bidder. In the top-right corner, select either "Sign In" or "Register" and complete the form. If you forget your password, use the "Forgot Password" link from the "Sign In" screen.', value: '0' },
    { question: 'Contacting the Organization hosting the Event/Auction', answer: 'For questions or assistance, go to "Contact Us" in the footer. Another option is on the item’s page, select the "Ask a question" tab and fill out the form to contact the hosting organization directly.', value: '1' },
    { question: 'How to Add/Edit/Remove Credit Card Information', answer: 'To manage your credit card details, sign into your bidder account, select "Welcome, (your name)" in the header and then select "Credit Cards".', value: '2' },
    { question: 'Types of Bidding - Straight Bidding vs. Proxy Bidding', answer: 'Straight Bidding involves placing a bid at a specific amount. Proxy Bidding allows the system to bid on your behalf up to a Maximum Bid Amount you set.  The system will automatically increase your bid as needed to maintain your leading position up to that maxmimum amount.', value: '3' },
    { question: 'How to Request a Bid Retraction', answer: 'To retract a bid, contact the hosting organization directly. On the item’s page, select "Ask a question" to request a bid retraction. BiddingForGood cannot process bid retraction requests from bidders.', value: '4' },
  ];

  sanitizeHtmlText(content: string): SafeHtml {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const txt = document.createElement('textarea');
      txt.innerHTML = content;
      const decodedContent = txt.value;
      return decodedContent ? this.sanitizer.bypassSecurityTrustHtml(decodedContent) : '';
    }
    return '';
  }

  formatDate(fecha: string): string {

    if (typeof window !== 'undefined') {
      // console.log('formated');
      const cleanedFecha = fecha.replace(/\[.*\]$/, '');
      const date = new Date(cleanedFecha);

      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
      return this.formatPlacedOnDate = this.datePipe.transform(date, 'MMM dd\'th\', h:mm a')!;
    }

    return '';
  }

  showLoginIframe() {
    // console.log('here');
    this.getLoginUrl();
  }

  getLoginUrl() {
    let urlHandler = (url: string) => {
      // console.log(url)
      this.loginUrl.set(url);
      this.isShowingLoginIframe.set(true);
    }
    let messageCallback = () => {
      this.isShowingLoginIframe.set(false);
      this.refreshNeeded = true;

    }
    this.authService.login(urlHandler, messageCallback, false, 0);
  }

  placeABid() {

    const biddingData: IBiddingRequest = {
      selectedCard: this.selectedCardId,
      bidType: this.selectedBidOption,
      amount: Number(this.selectedBid),
      coverTheFee: this.coverFeeConfirm,
      isFromBidderCommunity: false
    }

    // console.log(biddingData, this.idItemDetails)

    this.biddingService.postBidding(this.idItemDetails, biddingData).subscribe({
      next: (response: string) => {
        try {
          const parsed = JSON.parse(response);
          this.bidResponseSignal.set(parsed.status ?? '');
          this.showBidStatus = true;
          this.showConfirmTemplate = false;
          this.getItemDetails(this.idItemDetails);
          this.refreshNeeded = true;
        } catch (error) {
          console.error('Error parsing response:', error);
          this.bidResponseSignal.set('');
        }
      },
      error: (err) => {

        if (err.status === 500) {
          return;
        } else {
          const parsed = JSON.parse(err.error);
          this.apiBidError = parsed.message;
          this.showLowBidError = true;
        }


      }
    })
  }

  selectedCardName(): string | null {
    const selected = this.cardOptions().find(card => card.value === this.selectedCardId);
    return selected?.label || '';
  }

  goBackItemListing() {
    this.displayModal = false;
    this.lastItemId = null;

    this.modalStatusChanged.emit({
      refreshNeeded: this.refreshNeeded,
    });
    this.modalService.modalOpen.set(false);
  }

  hideError() {
    this.showLowBidError = false;
    this.showMaxBidError = false;
  }

  protected validateBid(): boolean {

    let valid = true;
    valid = valid && this.validateWholeNumber(this.selectedBid);
    valid = valid && this.errorLowBid();
    valid = valid && this.validateCreditCard();

    if (valid) {
      this.getFeeEndpoint();
      this.showConfirmTemplate = true;
    }


    return valid;
  }

  private validateCreditCard = () => {
    this.creditCardErrorMessage = this.getCreditCardErrorMessage(this.selectedCardId);
    return this.creditCardErrorMessage === '';
  }

  private validateWholeNumber(value: string): boolean {
    try {
      const regex = /^[0-9]+$/;
      return regex.test(value);
    } catch (error) {
      console.error("Error validating whole number:", error);
    }
    return false;
  }

  private errorLowBid() {
    if (this.selectedBid == null || this.selectedBid === '') {
      return false;
    }

    const bid = Number(this.selectedBid);


    if (this.itemMaximunBid != null && bid <= this.itemMaximunBid) {
      this.showMaxBidError = true;
      return false;
    } else if (this.itemMinimunBid > bid) {
      this.showLowBidError = true;
      return false;
    }

    return true;

  }

  hideConfirmTemplate() {
    // console.log('Back clicked');
    this.showConfirmTemplate = false;

  }

  onCoverFeeChange() {
    this.getFeeEndpoint();

  }

  getFeeEndpoint() {
    const coverFeeData: IFeeRequest = {
      auctionId: this.auctionId!,
      amount: Number(this.selectedBid),
      purchaseType: 3
    }

    this.paymentService.getFee(coverFeeData).subscribe({
      next: (response) => {
        this.feeSignalValue = response;
      }
    });

  }

  onClickBack() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
  }

  resetVariables() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
    this.showBidStatus = false;
    this.bidResponseSignal.set('');
    this.selectedBidOption = 'PROXY';
    this.selectedBid = '';
    this.coverFeeConfirm = this.auctionConfigSignal()?.isCoverTheFeeEnabled &&
      this.auctionConfigSignal()?.isCoverTheFeeOnByDefault ? true : false;
    this.modalService.modalOpen.set(true);

  }

  getBidPlaceholder(): string {
    const format = (amount: number) => `$${amount} ${this.currency()}`;

    const maxBid = Number(this.itemMaximunBid);
    const minBid = Number(this.itemMinimunBid);

    if (this.itemModal?.isLeader && maxBid >= minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(maxBid + 1)} Next Minimum Bid`;
    }

    if (this.itemModal?.isLeader && maxBid < minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(minBid)} Next Minimum Bid`;
    }

    this.myBidLabel = 'My Bid:';
    return `${format(minBid)} Next Minimum Bid`;

  }

  itemFavorite = () => {
    this.favoriteService.putFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        this.isFavorited = true;
        this.itemFavoriteSignal.set(true);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  removeItemFavorite() {

    this.favoriteService.deleteFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        this.isFavorited = false;
        this.itemFavoriteSignal.set(false);
      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  toggleFavorite(): void {
    if (this.isFavorited) {
      this.removeItemFavorite();
    }
    else {
      this.itemFavorite();
    }
  }

  onFavoriteChanged(updatedItem: IItem): void {
    const index = this.items.findIndex(i => i.id === updatedItem.id);
    if (index > -1) {
      this.items[index].isFavorite = updatedItem.isFavorite;
    }
  }

  onAddCreditCard() {
    this.modalService.openModal('credit-card', CreditCardInformationComponent, {
      width: '500px',
      modal: true,
      closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      },
      data: {
        // onCardAdded: () => this.loadCards()
      }
    });
  }

  onQuestionMark() {
    this.displayQuestionModal = true;
  }

  onModalClose() {
    // this.gallery = [];
    this.displayQuestionModal = false;
  }
  //Caption bid history
  captionLabels: Record<string, string> = {
    LEADING_BID: 'Leading Bid',
    TIE_WINNER: 'Tie Bid',
    RESERVE_MET: 'Reserve Met',
    BELOW_RESERVE: 'Below Reserve',
    LIVE_EVENT_BID: 'Live Event Bid',
    BID_EXTENSION: 'Bid Extension',
    STRAIGHT_BID: 'Straight Bid',
    BUY_NOW: 'Buy Now',
  }

  getCaptionLabel(caption: string): string {
    // this.activeCaption = caption;
    return this.captionLabels[caption] ?? null;
  }

  openCaptionModal(caption: string, bid: IItemBidHistory): void {
    // console.log(this.activeCaption);

    switch (caption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = true;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = true;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = true;
        break;
      case 'TIE_WINNER':
        this.tieDetails = bid.tieDetails;
        this.displayTieWinBidModal = true;
        break;
    }
  }

  onModalExplanationClose() {
    // console.log(this.activeCaption);
    switch (this.activeCaption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = false;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = false;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = false;
        break;
      case 'TIE_WINNER':
        this.displayTieWinBidModal = false;
        break;
    }
  }

  openReserveModal() {

    this.modalService.openModal('has-reserve-item', BelowReserveComponent, {
      width: '500px',
      modal: true,
      // closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      }
    });
  }

  onAskAQuestion() {
    if (this.askAQuestionControl && this.askAQuestionControl.trim() !== '') {
      if (this.isAuthenticated().isAuthenticated) {
        this.postAsqkAQuestion()
      } else {
        this.openLoginModalFavorite(this.postAsqkAQuestion);
      }
    } else {
      this.responseError = 'Question is a required field';
      return;
    }
  }

  onQuestionChange() {
    if (this.askAQuestionControl.trim() !== '')
      this.responseError = '';
  }

  postAsqkAQuestion = (): void => {
    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userEmail = result.email ?? '';
      }
    });

    const askAQuestionObj: IAskAQuestionRequest = {
      question: this.askAQuestionControl,
      email: this.userEmail ?? 'test@gmail.com'
    };

    this.recaptchaV3Service.execute(environment.siteKey, 'ask_question', (token: string) => {

      const recaptchaDom = document.querySelector('.grecaptcha-badge') as HTMLElement;

      recaptchaDom.style.visibility = 'visible';

      this.apiService.postAskAQuestion(this.idItemDetails, askAQuestionObj, token).subscribe({
        next: (response) => {
          this.messageService.success(`Your question has been sent to the auction team. They will contact you at ${this.userEmail} within a few days. `);
        },
        error: (err) => {
          let errorMsg = 'unknown error';

          if (typeof err.error === 'string') {
            try {
              const parsed = JSON.parse(err.error);
              errorMsg = parsed.message || errorMsg;

            } catch (e) {
              errorMsg = err.error;
            }
          }
          else if (err.error && err.error.errorMessage) {
            errorMsg = err.error.errorMessage;
          }

          this.messageService.error(errorMsg || 'unknown error');
        }
      });

      setTimeout(() => {
        recaptchaDom.style.visibility = 'hidden';
        this.askAQuestionControl = '';
      }, 3000);
    });
  }

  protected openPopupCenter(pageURL: string, title: string, w: number, h: number) {
    if (isPlatformBrowser(this.platformId)) {
      var windowSize = {
        width: w,
        height: h
      };
      var windowLocation = {
        left: ((window.screen.availWidth / 2) - (windowSize.width / 2)),
        top: ((window.screen.availHeight / 2) - (windowSize.height / 2))
      };
      window.open(pageURL, title, 'width=' + w + ', height=' + h + ', left=' + windowLocation.left + ', top=' + windowLocation.top);
    }
  }

  private shareText = computed(() => {
    if (this.shareTextInput() !== "") {
      return this.shareTextInput();
    }

    if (this.itemDetailsSingalModal() != null) {
      const item = this.itemDetailsSingalModal();

      return item?.name!;
    }
    return "Bidding For Good";
  });

  protected facebookShareUrl = computed(() => {
    const item = this.itemDetailsSingalModal();
    if (isPlatformBrowser(this.platformId) && item) {
      const url = `${environment.apiUrl}/v3/social-media-sharing/item/${this.idItemDetails}`;
      // console.log(url, this.idItemDetails, url);
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }
    return "";
  });

  protected twitterShareUrl = computed(() => {
    const item = this.itemDetailsSingalModal();
    if (isPlatformBrowser(this.platformId) && item) {
      const url = `${environment.apiUrl}/v3/social-media-sharing/item/${this.idItemDetails}`;
      return "https://twitter.com/intent/tweet?url=" +
        encodeURIComponent(url) +
        "&text=" +
        encodeURIComponent(this.shareText());
    }
    return "";
  });

  protected linkedinShareUrl = computed(() => {
    const item = this.itemDetailsSingalModal();
    if (isPlatformBrowser(this.platformId) && item) {
      const url = `${environment.apiUrl}/v3/social-media-sharing/item/${this.idItemDetails}`;
      return "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(url);
    }
    return "";
  });

  protected copyUrl = computed(()=> {
    const item = this.itemDetailsSingalModal();
    if (isPlatformBrowser(this.platformId) && item) {
      const url = `${environment.apiUrl}/v3/social-media-sharing/item/${this.idItemDetails}`;
      return url;
    }
    return "";
  })

  protected onCopyUrl() {
    this.messageService.success('URL copied to clipboard!');
  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }



openFullScreen(index: number) {


    this.activeIndex = index;

  this.galleryFullscreen = [...this.galleryFormatted];

  this.displayFullScreen = true;

    //  console.log( this.galleryFullscreen, 'gallery')
}


}




